import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const Loader = ({ onComplete, waitFor }) => {
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(true);
  // When a promise is provided, the bar holds at 92% until it settles, so the
  // preloader only completes after the hero video has really loaded.
  const readyRef = useRef(!waitFor);

  useEffect(() => {
    if (!waitFor) return undefined;
    let active = true;
    const markReady = () => {
      if (active) readyRef.current = true;
    };
    waitFor.then(markReady, markReady);
    // Safety net: never keep the site locked if the network hangs.
    const safety = setTimeout(markReady, 12000);
    return () => {
      active = false;
      clearTimeout(safety);
    };
  }, [waitFor]);

  useEffect(() => {
    let n = 0;
    const id = setInterval(() => {
      n += Math.floor(Math.random() * 9) + 4;
      if (!readyRef.current) {
        n = Math.min(n, 92);
        setCount(n);
        return;
      }
      if (n >= 100) {
        n = 100;
        clearInterval(id);
        setTimeout(() => setShow(false), 420);
      }
      setCount(n);
    }, 50);
    return () => clearInterval(id);
  }, []);

  return (
    <AnimatePresence onExitComplete={onComplete}>
      {show && (
        <motion.div
          data-testid="site-loader"
          className="fixed inset-0 z-[120] flex items-center justify-center bg-white"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex flex-col items-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
            >
              <img
                src="/loading-screen-logo.png"
                alt="VideoActive"
                className="h-14 w-auto select-none sm:h-16"
                draggable={false}
              />
            </motion.div>
            <div className="mt-8 h-[3px] w-56 overflow-hidden rounded-full bg-brand-100">
              <div
                className="h-full bg-brand-500 transition-[width] duration-150 ease-out"
                style={{ width: `${count}%` }}
              />
            </div>
          </div>

          <span className="absolute bottom-6 left-6 text-[11px] font-semibold uppercase tracking-[0.3em] text-brand-700">
            {count < 100 ? "Φόρτωση" : "Έτοιμο"}
          </span>
          <span className="absolute bottom-4 right-6 font-display text-5xl font-bold text-ink/10 tabular-nums">
            {count}
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
